import { render, staticRenderFns } from "./WorkRecorder.vue?vue&type=template&id=2315ce31&"
import script from "./WorkRecorder.vue?vue&type=script&lang=ts&"
export * from "./WorkRecorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports